import { Language } from '@coolblue-development/constants';

const sortingKeyTranslations = {
  en: 'sort',
  fr: 'trier',
  de: 'sortieren',
  nl: 'sorteren'
};

export default function getSortingQueryParameterKey(language: Language): string {
  return sortingKeyTranslations[language] || sortingKeyTranslations.nl;
}
